import { render, staticRenderFns } from "./OtherRecordOut.vue?vue&type=template&id=a4d2a498&scoped=true&"
import script from "./OtherRecordOut.vue?vue&type=script&lang=js&"
export * from "./OtherRecordOut.vue?vue&type=script&lang=js&"
import style0 from "./OtherRecordOut.vue?vue&type=style&index=0&id=a4d2a498&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d2a498",
  null
  
)

export default component.exports